export default __webpack_public_path__ + "static/social media 9-a26b96ddd9d74678188141c8dd102b9e.webp";